module.exports = __webpack_public_path__ + "img/zdd_invite_lz_3.92c9a49c.png";